import React from 'react';
import PropTypes from 'prop-types';

import Services from '../components/Pages/Services';

const ServicesPage = ({ data }) => {
  const servicesData = data.allContentfulServicesPage.edges[0].node;
  return <Services data={servicesData} />;
};

ServicesPage.propTypes = {
  data: PropTypes.object,
};

export default ServicesPage;

export const enServicesQuery = graphql`
  query EnServicesQuery {
    allContentfulServicesPage(filter: { node_locale: { eq: "en" } }) {
      edges {
        node {
          node_locale
          title
          metaDescription
          venteBannerTitle
          mecaBannerTitle
          mecaBannerNav
          analysesBannerTitle
          analysesBannerList
          analysesBannerListIcon
          headerImage {
            title
            sizes(quality: 100) {
              ...GatsbyContentfulSizes_withWebp
            }
          }
          venteBannerImage {
            title
            sizes(quality: 100) {
              ...GatsbyContentfulSizes_withWebp
            }
          }
          mecaBannerDepannageImage {
            title
            sizes(quality: 100) {
              ...GatsbyContentfulSizes_withWebp
            }
          }
          mecaBannerGarantieImage {
            title
            sizes(quality: 100) {
              ...GatsbyContentfulSizes_withWebp
            }
          }
          mecaBannerMaintenanceImage {
            title
            sizes(quality: 100) {
              ...GatsbyContentfulSizes_withWebp
            }
          }
          mecaBannerAmeliorationImage {
            title
            sizes(quality: 100) {
              ...GatsbyContentfulSizes_withWebp
            }
          }
          mecaBannerRevisionImage {
            title
            sizes(quality: 100) {
              ...GatsbyContentfulSizes_withWebp
            }
          }
          mecaBannerProtectionImage {
            title
            sizes(quality: 100) {
              ...GatsbyContentfulSizes_withWebp
            }
          }
          venteBannerContent {
            childMarkdownRemark {
              html
            }
          }
          mecaBannerDepannageContent {
            childMarkdownRemark {
              html
            }
          }
          mecaBannerGarantieContent {
            childMarkdownRemark {
              html
            }
          }
          mecaBannerMaintenanceContent {
            childMarkdownRemark {
              html
            }
          }
          mecaBannerAmeliorationContent {
            childMarkdownRemark {
              html
            }
          }
          mecaBannerRevisionContent {
            childMarkdownRemark {
              html
            }
          }
          mecaBannerProtectionContent {
            childMarkdownRemark {
              html
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/services.en.js